'use client';

import { SectionHeader } from '../shared';

interface Product {
  semantic_id?: string;
  name?: string;
  image_url?: string | null;
  list_price?: number | null;
}

interface ProductsSectionProps {
  products: Product[] | null | undefined;
  label?: string | null;
  maxItems?: number | null;
}

export function ProductsSection({ products, label, maxItems }: ProductsSectionProps) {
  if (!products || products.length === 0) {
    return null;
  }

  const displayProducts = maxItems ? products.slice(0, maxItems) : products;

  return (
    <div>
      <SectionHeader title={label || 'PRODUCTS'} count={products.length} />
      <div className="grid grid-cols-2 gap-2">
        {displayProducts.map((product) => (
          <div
            key={product.semantic_id}
            className="p-2 rounded-lg bg-card border border-border"
          >
            {product.image_url && (
              <div className="aspect-square bg-muted rounded overflow-hidden mb-1">
                <img
                  src={product.image_url}
                  alt={product.name || 'Product'}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <div className="text-xs font-medium truncate">
              {product.name || 'Product'}
            </div>
            {product.list_price != null && (
              <div className="text-xs text-muted-foreground">
                ${product.list_price.toFixed(0)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
